<template>
	<div class="hdl-sso-confirmation p-4">
		<div class="hdl-auth-container mb-8">
			<div class="mb-5 flex flex-row justify-center items-center">
				<img src="/static/images/logo.svg" width="32" alt="logo" class="auth-medley-logo" />
			</div>
			<div class="hdl-heading-secondary text-center mb-3">
				Confirm account linking
			</div>
			<div class="text-center mb-5">
				Login to your existing account to confirm linking your {{ ssoName }} account.
			</div>

			<div v-if="errors.length > 0" class="mb-5">
				<div class="auth-error mb-2" v-for="(error, index) of errors" :key="index">
					{{ error }}
				</div>
			</div>
			<div class="mb-5">
				<div class="mb-1 text-lg font-semibold">Email</div>
				<hdl-textbox
					v-model="email"
					hdl-style="auth"
					class="w-full"
					readonly
					disabled
				/>
			</div>
			<div class="mb-5">
				<div class="mb-1 text-lg font-semibold">Password</div>
				<hdl-textbox
					v-model="password"
					hdl-style="auth"
					class="w-full"
					focus-on-mount
					password
					@enter="confirmLink"
				/>
			</div>
			<div class="mb-8">
				<hdl-button
					@click.prevent="confirmLink"
					label="Link account"
					hdl-style="primary"
					size="lg"
					class="w-full text-lg"
					:disabled="!formIsValid"
				/>
			</div>
			<div class="text-center hdl-footnote-text mb-4">
				<div>
					Forgot your password?
					<a
						href="#"
						@click.prevent="$router.push('/account/password/reset/')"
					>Click here</a>.
				</div>
				<div class="mt-1">
					Don't have an account?
					<a
						href="#"
						@click.prevent="$router.push('/account/register/')"
					>Sign up</a>.
				</div>
			</div>
			<div class="hdl-footnote-text text-center">
				By signing in you agree to the
				<a href="https://medley.so/company/terms-of-service" target="_blank">Terms of Service</a> and
				acknowledge the <a href="https://medley.so/company/privacy-policy" target="_blank">Privacy Policy</a>.
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';

import { fetcher, FetchResult, KnownFetchResult } from '@/common/fetcher';
import { SSOIntegrations } from '@/common/interfaces';

@Component
export default class SSOLinkConfirmationPage extends Vue {
	email: string = "";
	password: string = "";

	errors: Array<string> = [];

	ssoType: SSOIntegrations;
	token: string;

	mounted(): void {
		if (
			!this.$route.query.i
			|| !this.$route.query.e
			|| !this.$route.query.t
		) {
			this.$router.push('/');
			return;
		}

		this.ssoType = parseInt(this.$route.query.i as string);
		this.email = this.$route.query.e as string;
		this.token = this.$route.query.t as string;
	}

	confirmLink(): void {
		if (!this.formIsValid) {
			return;
		}

		fetcher.Post(
			'/account/sso/link/',
			{
				token: this.token,
				password: this.password,
				email: this.email
			}
		).then(
			(result: KnownFetchResult<{next: string}>) => {
				if (result.response.ok && result.json.success) {
					window.location.replace(result.json.data.next);
				} else if (!result.json.success) {
					if (result.json.message) {
						this.errors = [result.json.message];
					}
				}
			}
		);
	}

	get formIsValid(): boolean {
		return (
			this.password.trim().length > 0
			&& this.email.trim().length > 0
			&& this.token.length > 0
		);
	}

	get ssoName(): string {
		switch(this.ssoType) {
			case SSOIntegrations.GOOGLE:
				return 'Google';
		}

		return 'external';
	}
}
</script>

<style lang="scss">

.auth-error {
	@apply text-center bg-hdl-red-bg rounded py-2 text-hdl-red;
}
</style>
